// extracted by mini-css-extract-plugin
export default {"button":"ContextMenu_button__XVuGa","icon":"ContextMenu_icon__82ZkZ","menuItem":"ContextMenu_menuItem__IHUwR"};